import terminalService from '../../api/terminal'

// let cacheEmployee = null

export default {

  // Reset employeeCache
  // resetEmployeeCache() {
  //   cacheEmployee = null;
  // },

  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    return terminalService.Api().get('attachment', { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return terminalService.Api().get(`attachment/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return terminalService.Api().post('attachment', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return terminalService.Api().put(`attachment/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return terminalService.Api().delete(`attachment/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  uploadAndCreate(attachmentData) {
    const bodyFormData = new FormData()
    bodyFormData.append('attachmentFile', attachmentData.file)
    bodyFormData.append('name', attachmentData.name)
    bodyFormData.append('EmployeeId', attachmentData.EmployeeId)
    return terminalService.Api().post('attachment/upload', bodyFormData)
      .then(response => response.data)
      .catch((error) => { throw error })
  }

}
